import { createContext, useContext } from "react";
import {
  getStoreHostRewardType,
  updateStoreHostRewardType,
} from "Services/storeService";
import AuthContext from "./AuthContext";
import logger from "utils/logger";

const HostRewardTypeContext = createContext();
export default HostRewardTypeContext;

export const HostRewardTypeProvider = ({ children }) => {
  const { updateProfile } = useContext(AuthContext);

  /**
   * Fetches the current host reward type from the API
   * @returns {Promise} Response object containing host_reward_type
   */
  const getStoreRewardType = async () => {
    try {
      const response = await getStoreHostRewardType();
      return response;
    } catch (error) {
      logger.error("Error fetching store reward type:", error);
      throw error;
    }
  };

  /**
   * Updates the host reward type (cash, store_credit, or gift_card)
   * @param {string} hostRewardType - Either "cash", "store_credit", or "gift_card"
   * @returns {Promise} Response object
   */
  const updateStoreRewardType = async (hostRewardType) => {
    try {
      // API expects: { "host_reward_type": "store_credit" } or { "host_reward_type": "cash" } or { "host_reward_type": "gift_card" }
      // hostRewardType should be "cash", "store_credit", or "gift_card" (lowercase with underscore)
      const response = await updateStoreHostRewardType({
        host_reward_type: hostRewardType,
      });
      if (response?.status === 200) {
        // Refresh user profile to get updated reward type
        if (updateProfile) {
          await updateProfile();
        }
      }
      return response;
    } catch (error) {
      logger.error("Error updating store reward type:", error);
      throw error;
    }
  };

  const contextData = {
    getStoreRewardType,
    updateStoreRewardType,
  };

  return (
    <HostRewardTypeContext.Provider value={contextData}>
      {children}
    </HostRewardTypeContext.Provider>
  );
};
